module.exports = __webpack_public_path__ + "img/ink.37a38057.png";